import { simplePath } from 'ze-api-contract/utils';

export const POST_RESEND_VERIFICATION_EMAIL = '/v2/user/resend-verification-email';

export function resend_verification_email_path(): string {
  return simplePath(POST_RESEND_VERIFICATION_EMAIL, {});
}
